import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class HomeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      if (!environment.deviceMobile) {
        // do nothing
      } else {
        this.router.navigate(['/respondent']);
      }
      resolve(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/home.guard.ts